<template>
  <h1 >Association Logs</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-xsm btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              />
            </div>
          </div>
        </div>


      <div class="clearfix"></div>

      <div class="content-section">
        <div class="alert alert-warning" role="alert">After setting filters or changing sorting order, click "Apply filters"
          to re-query the database</div>
        <div class="row">
          <div class="col-md-4">
            <FormKit
                type="datepicker"
                label="Start Date"
                v-model="selectedStartDate"
                format="DD/MM/YYYY"
                timezone="Europe/London"
                clearable
                :key="datepickerClearedKey"
            ></FormKit>
          </div>

          <div class="col-md-4">
            <FormKit
                type="datepicker"
                label="End Date"
                v-model="selectedEndDate"
                format="DD/MM/YYYY"
                timezone="Europe/London"
                clearable
                :key="datepickerClearedKey"
            ></FormKit>
          </div>

        </div>
        <div class="row">
          <div class="col-md-4">
            <label class="formkit-label">Search: </label>
            <div class="formkit-inner">
              <input type="text" class="formkit-input" v-model="searchValue">
            </div>

          </div>
          </div>

        <div class="action-bar">
          <button @click="clearFilter" id="clearFilter">Clear filter</button>&#160;
          <button @click="exportLogs" id="exportLogs">Export Logs</button>&#160;
          <button @click="applyFilter" id="applyFilter1">Apply filter</button>
        </div>

        <div>
          <easy-data-table
              v-model:server-options="serverOptions"
              :server-items-length="serverItemsLength"
              :headers="headers"
              :items="associationLogs"
              :search-field="searchField"
              :search-value="searchValue"
              :loading="loading"
              alternating
              border-cell
              buttons-pagination
              multi-sort
              server-mode
          >
            <template #empty-message>
              nothing here for the moment
            </template>


            <template #item-batch_id="{ batch_id }">
              <router-link target="_blank" :to="{ name: 'ViewBatch', params: { id: batch_id } }">
                <div > {{formatLondon(batch_id)}}</div>
              </router-link>
            </template>
            <template #item-customer_name="item">
              <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
                <div >{{ item.customer_name }}</div>
              </router-link>
            </template>
            <template #item-garment_type="item">
              <router-link target="_blank" :to="{ name: 'GarmentTypeEdit', params: { id: item.garment_type_id } }">
                <div >{{ item.garment_type }}</div>
              </router-link>
            </template>
            <template #item-operations="item">
              <font-awesome-icon
                  icon="edit"
                  size="1x"
                  class="operation-icon"
                  title="Re-asign"
                  @click="reassignBatch(item)">
              </font-awesome-icon>
            </template>
            <template #loading>
              <font-awesome-icon
                  icon="spinner"
                  size="2x"
                  title="Loading"
                  spin
              >
              </font-awesome-icon>
            </template>
          </easy-data-table>
        </div>
      </div>

    </div>
  </div>

  <div class="modal" tabindex="-1" id="reassignBatchModal" ref="reassignBatchModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Re-assign all towels to: </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="content-section">
            <div class="mb-4">
              <label class="formkit-label">Current batch selected:</label>
              {{editingBatch.batch_id}}<br/>
              {{editingBatch.customer_name}} -> {{editingBatch.garment_type}} (qty: {{editingBatch.quantity}})
            </div>
            <div>
              <FormKit
                  v-model="rAccount.customer_id"
                  type="autocomplete"
                  name="customer_id"
                  id="customer_id"
                  label="Select Account"
                  help="Only accounts that have rfid_account=1 "
                  placeholder="RFID Accounts"
                  :options="rfidaccounts"
                  :value="rAccount.customer_id"
                  open-on-click
                  clear-search-on-open
                  searchable
                  validation="required"
                  @input="onAccountChange"
              />
            </div>

            <div v-if="!showEmptyGarment">
              <FormKit
                  v-model="accountGarment.garmenttype_id"
                  type="autocomplete"
                  name="garmenttype_id"
                  id="garmenttype_id"
                  label="Select Garment"
                  placeholder="Select Garment"
                  :options="accountGarments"
                  :value="accountGarment.garmenttype_id"
                  open-on-click
                  clear-search-on-open
                  searchable
                   @input="onGarmentChange"
              />

              <FormKit
                  v-model="accountGarmentService.service_id"
                  type="autocomplete"
                  name="service_id"
                  id="service_id"
                  label="Select Service"
                  placeholder="Select Service"
                  :options="accountGarmentServices"
                  open-on-click
                  clear-search-on-open
                  searchable
              />
            </div>
            <div v-if="showEmptyGarment" class="row">
              <label class="formkit-label">Select Garment</label>
              <div class="error-message">No Custom Garments</div>
              <div class="col-md-6">
                <FormKit
                    type="button"
                    label="Create"
                    help="Opens in new tab"
                    input-class="$reset btn-rfid-sm btn btn-rfid btn-re-assign"
                    @click="goTo('NewGarment')"
                />
              </div>
              <div class="col-md-6">
                <FormKit
                    type="button"
                    label="Refresh"
                    input-class="$reset btn-rfid-sm btn btn-rfid btn-pieceup"
                    @click="goTo('RefreshGarment')"
                />
              </div>
            </div>

            

            <FormKit
                v-model="editingBatch.uniquepw"
                type="password"
                name="uniquepw"
                id="uniquepw"
                label="Manager Pin"
                placeholder="Manager Pin"
                validation="required"
            />

          </div>
        </div>
        <div class="modal-footer">
          <button  type="button" class="btn btn-primary" @click="reassignBatchTags">Re-assign</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">OK</button>

          <div v-if="successMessage">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success">{{successMessage}}</div>
          </div>
          <div v-if="errorMessage">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger">{{errorMessage}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script setup>

import {onMounted, ref, inject, reactive, watch} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import RFIDService from "@/services/RFIDService";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import {  formatLondon } from '@/utils/dateUtils';
import { closeModal, openModal } from '@/utils/modalUtils';

const associationLogs =  ref([]);
const headers = [
  { text: "Transaction Timestamp", value: "batch_id", sortable: true  },
  { text: "Account Name", value: "customer_name", sortable: true },
  { text: "Account ID", value: "customer_id", sortable: true },
  { text: "Garment Name", value: "garment_type", sortable: true },
  { text: "Service Type", value: "service_type", sortable: true },
  { text: "Quantity", value: "quantity", sortable: true },
  { text: "User", value: "user", sortable: true },
  { text: "Actions", value: "operations" },
];
const searchField = ref("batch_id");
const searchValue = ref("");

const nowDate = new Date();
const currentDate = new Date(Date.UTC(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate()));
const defaultStartDate = new Date(new Date().setDate(currentDate.getDate() - 7));

const selectedStartDate = ref(defaultStartDate);
const selectedEndDate = ref(currentDate);
const datepickerClearedKey = ref(0);

const forceRenderDatepicker = () => {
  datepickerClearedKey.value += 1;
};

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  sortBy: "",
  sortType: "",
  exportFormat: "none",
  start_date: defaultStartDate,
  end_date: currentDate,
  search: "",
});

const reassignBatchModal = ref(null);
const errorMessage = ref(false);
const successMessage = ref(false);
const editingBatch = ref({
  batch_id: 0,
  customer_name: "",
  customer_id: 0,
  garment_type_id: 0,
  garment_type: "",
  quantity: 0,
  user_id: 0,
  user: "",
  uniquepw: ""
});
const showEmptyGarment  = ref(false);
const rAccount = ref({
  customer_id: 0,
  fullname: "",
});
const accountGarment = ref({
  garmenttype_id: 0,
  fullname: "",
});
const accountGarmentService = ref({
  service_id: 0,
  fullname: "",
});
const accountGarments = ref([]);
const accountGarmentServices = ref([]);
const rfidaccounts = ref([]);

const  createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}

// Watch for changes in sorting (or pagination)
watch(serverOptions, (newOptions, oldOptions) => {
  
   // If sortBy or sortType is null, treat as "no sort"
  if (!newOptions.sortBy || !newOptions.sortType) {
    // Handle the "no sort" case, e.g., reset to default sort or unsorted
    return;
  }

  // Only apply filter if sortBy or sortType changed
  if (
    newOptions.sortBy !== oldOptions.sortBy ||
    newOptions.sortType !== oldOptions.sortType
  ) {
    applyFilter();
  }
}, { deep: true });

const reassignBatchTags = async () => {
  if (rAccount.value.customer_id === 0 || accountGarment.value.garmenttype_id === 0
    || accountGarmentService.value.service_id === 0
      || (editingBatch.value.uniquepw === 0 || editingBatch.value.uniquepw === "")
  ) {
    alert("All fields are mandatory");
    return false;
  }

  //re-assign
  RFIDService.reassignGarmentsToCustomer(
      editingBatch.value.batch_id, editingBatch.value.uniquepw,
      rAccount.value.customer_id, accountGarment.value.garmenttype_id,
      accountGarmentService.value.service_id
  )
      .then(response => {
        if (response.data.success == "true" || response.data.success === true) {

          successMessage.value = response.data.message;
          applyFilter();
          setTimeout(() => {
            closeModal(reassignBatchModal);
          }, 3000);

        }
        else {
          errorMessage.value = response.data.message;
          console.log(response);
        }
      })
      .catch(e => {
        console.log(e);
      });
}
const emptyReasignForm = async () => {
  editingBatch.value.batch_id = 0;
  editingBatch.value.customer_name = '';
  editingBatch.value.customer_id = 0;
  editingBatch.value.garment_type_id = 0;
  editingBatch.value.garment_type = '';
  editingBatch.value.quantity = 0;
  editingBatch.value.user_id = 0;
  editingBatch.value.user = '';
  editingBatch.value.uniquepw = '';
  rAccount.value.customer_id = 0;
  accountGarment.value.garmenttype_id = 0;
  successMessage.value = '';
  errorMessage.value = '';
}
const reassignBatch = async (batch) => {

  emptyReasignForm();
  editingBatch.value.batch_id = batch.batch_id;
  editingBatch.value.customer_name = batch.customer_name;
  editingBatch.value.customer_id = batch.customer_id;
  editingBatch.value.garment_type_id = batch.garment_type_id;
  editingBatch.value.garment_type = batch.garment_type;
  editingBatch.value.quantity = batch.quantity;
  editingBatch.value.user_id = batch.user_id;
  editingBatch.value.user = batch.user;
  editingBatch.value.uniquepw = batch.uniquepw;
  console.log("Item.batch_id", batch.batch_id);
  console.log("Item.customer_name", batch.customer_name);
  openModal(reassignBatchModal);
}

const applyFilter = (resetPage) => {
  let updateOptions = serverOptions.value;

  if (typeof searchValue.value != "undefined") {
    updateOptions.search = searchValue.value;
  }
  if (selectedStartDate.value !== "" && typeof selectedStartDate.value != "undefined") {
    selectedStartDate.value = createDateAsUTC(new Date(selectedStartDate.value));
    updateOptions.start_date = selectedStartDate.value;
  }
  if (selectedEndDate.value !== "" && typeof selectedEndDate.value != "undefined") {
    selectedEndDate.value = createDateAsUTC(new Date(selectedEndDate.value));
    updateOptions.end_date = selectedEndDate.value;
  }
  if (resetPage) {
    updateOptions.page = 1;
  }
  serverOptions.value = updateOptions;
  loadRFIDassociationLogsList();
};

const clearFilter = () => {

  const updateServerOptions = serverOptions.value;
  searchValue.value = "";
  selectedStartDate.value = defaultStartDate;
  selectedEndDate.value = currentDate;
  serverOptions.value = updateServerOptions;

  forceRenderDatepicker();
  applyFilter(true);
};

const refreshgarment = async () => {
  //get the garments type for selected account
  RFIDService.getAccountGarmentType(rAccount.value.customer_id)
      .then(response => {
        const garments = response.data.data.garmentstype;

        if (garments.length == 0) {
          showEmptyGarment.value = true;
        }
        else {
          showEmptyGarment.value = false;
          accountGarments.value = garments.map((response) => {
            return {
              label: response.garment_details.garmenttype,
              value: response.garmenttype_id,
            }
          });
          accountGarments.value.unshift({
            label: " - select garment - ",
            value: "0"
          });
        }


      })
      .catch(e => {
        console.log(e);
      });
}

watch(() => serverOptions.value.page, () => {
  applyFilter(false)
});
watch(() => serverOptions.value.rowsPerPage, () => {
 applyFilter(false)
});

// When user selects a new account
const onAccountChange = async (customerId) => {
  rAccount.value.customer_id = customerId;

  await refreshgarment();
  accountGarment.value.garmenttype_id = 0;
  accountGarmentService.value.service_id = 0;
};

// When user selects a new garment
const onGarmentChange = async (garmenttypeId) => {
  accountGarment.value.garmenttype_id = garmenttypeId;

  const selectedGarment = accountGarments.value.find(
      // {label: 'Surname-16 Firstname-16', value: '__mask_1', __original: 16}
      garment =>  Number(garment.__original) == Number(garmenttypeId)  || Number(garment.value) == Number(garmenttypeId)
  );

  if (selectedGarment){
    accountGarment.value.fullname = selectedGarment.label || "";
  }

  await refreshgarmentservice();
};
const refreshgarmentservice = async () => {

  accountGarmentService.value = { service_id: 0, fullname: "" };
  accountGarmentServices.value = [];

  return RFIDService.getAccountGarmentTypeService(accountGarment.value.garmenttype_id)
      .then(response => {
        const services = response.data.data.service_prices;

        if (services.length == 0) {
          accountGarmentServices.value = [{
            label: " - select service - ",
            value: 0
          }];
          accountGarmentService.value = {
            service_id: 0,
            fullname: "",
          };
        } else {
          accountGarmentServices.value = services.map((response) => {
            return {
              label: response.servicetype,
              value: response.servicetype_id,
            }
          });
          accountGarmentServices.value.unshift({
            label: " - select service - ",
            value: 0
          });

          const realServicesCount = services.length;
          if (realServicesCount === 1 ) {
            // Auto-select the only service
            accountGarmentService.value.service_id = services[0].servicetype_id;
            accountGarmentService.value.fullname = services[0].servicetype;
          } else {
            // Reset if not restoring and not exactly one service
            accountGarmentService.value.service_id = 0;
            accountGarmentService.value.fullname = "";
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
}
const exportLogs = async () => {
  loading.value = true;
  serverOptions.value.type = "csv";
  await RFIDService.downloadRFIDAssociationLogs(serverOptions.value);
  loading.value = false;
};
const goTo = (pageSection, item=false) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/dashboard",
          "_self"
      );
      break;
    case "NewGarment":
      window.open(
          "/garmenttype",
          "_blank"
      );
      break;
    case "RefreshGarment":
      refreshgarment();
      break;
  }
}
const loadRFIDassociationLogsList = async () => {

  const dateoptions = { year: 'numeric', month: 'numeric', day: 'numeric' }
  serverOptions.value.start_date = new Date(serverOptions.value.start_date).toLocaleDateString('fr-CA', dateoptions);
  serverOptions.value.end_date = new Date(serverOptions.value.end_date).toLocaleDateString('fr-CA', dateoptions);

  //console.log(serverOptions.value);
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await RFIDService.searchRFIDAssociationLogsList(serverOptions.value);
  associationLogs.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
}
const loadRFIDAccounts = async () => {
  // Get all accounts that have parameter rfid_account = 1
  //fullname customer_id for autocomplete
  RFIDService.getRFIDAccounts()
      .then(response => {
        const rAccounts = response.data.data.customers;

        rfidaccounts.value = rAccounts.map((response) => {
          return {
            label: response.surname+' '+response.firstname,
            value: response.customerid,
          }
        });
        rfidaccounts.value.unshift({
          label: " - select account - ",
          value: "0"
        });
      })
      .catch(e => {
        console.log(e);
      });
}
onMounted(async () => {
  reassignBatchModal.value = new bootstrap.Modal('#reassignBatchModal', {})
  loadRFIDassociationLogsList();
  // Load accounts that have parameter rfid_account = 1 - in case some batches need to be re-assigned
  loadRFIDAccounts();

});

</script>


<style scoped>
.main-section > h1:first-child {
  background: var(--associate-tag-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}
</style>
